import { CalendarTranslateService } from '../../../../../modules/UIKit/services/calendarTranslate.service';
import { Component, AfterViewChecked, ViewChild, ElementRef } from '@angular/core'
import { ControlWidget } from 'ngx-schema-form'

@Component({
  selector: 'my-custom-date-input',
  template: `
      <div class="ui-g-12 sf-field-container">
        <div class="ui-g-12 ui-md-4">
          <span class="label" [attr.for]="id" [ngClass]="{'required': -1!==(formProperty.parent.schema.required||[]).indexOf(formProperty.path.split('/').slice(-1)[0])}">
            {{ schema.description }}
          </span>
        </div>
        <div class="ui-g-12 ui-md-8">
          <p-calendar
            #calendar
            [dateFormat]="srvCalendarTranslate.pcalendarTranslate.dateFormat"
            [locale]="srvCalendarTranslate.pcalendarTranslate"
            showIcon="true"
            yearRange="1900:2099"
            [placeholder]="srvCalendarTranslate.pcalendarTranslate.dateFormat"
            inputName="schema.description"
            [(ngModel)]="dateValue"
            [defaultDate]="dateValue"
            (onSelect)="update(calendar)"
            [readonlyInput]="true"
            [monthNavigator]="true"
            [yearNavigator]="true"
            [disabled]="schema.readOnly||false"
          ></p-calendar>
        </div>
      </div>
  `,
  styleUrls: ['./custom-widgets-styles.css']
})
export class CalendarWidget extends ControlWidget implements AfterViewChecked {
  checkCount = 0;
  dateValue: Date;
  @ViewChild('calendar') calendar: ElementRef;

  constructor(public srvCalendarTranslate: CalendarTranslateService) {
    super()
  }

  ngAfterViewChecked() {
    if (this.checkCount === 0) {
      this.dateValue = this.control.value;
      this.updateYearMonthSelect(this.calendar);
      this.checkCount++;
    }
  }

  update(calendar) {
    this.control.setValue(this.dateValue);
    this.updateYearMonthSelect(calendar);
  }

  /**
   * Aggiorna i dropdown per la selezione di mese ed anno.
   */
  updateYearMonthSelect(calendar) {
    if (this.control.value) {
      calendar.currentYear = this.control.value.getFullYear();
      calendar.currentMonth = this.control.value.getMonth();
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/views/administration/apps-config/json-schema-form/custom-widgets/calendar.widget.ts